import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from 'react-router';

import { useMe } from '../auth/session';
import { ErrorBanner, LoadingClinic } from '../components/ui/States';
import { setLanguage, toLanguage } from '../i18n';
import { useRealtime } from '../realtime/useRealtime';

import { OfflineBanner } from './OfflineBanner';
import { Rail } from './Rail';
import { SessionWarning } from './SessionWarning';
import { TopBar } from './TopBar';

/** Pantallas con sesión y clínica activa: rail + barra superior + contenido (docs/08 §3). */
export function AppShell() {
  const { t } = useTranslation();
  const me = useMe();
  const userId = me.data?.id;
  const locale = me.data?.locale;
  const applied = useRef<string | undefined>(undefined);
  useRealtime(userId, me.data?.activeClinicId);

  // Al entrar, el idioma del perfil manda sobre el del navegador. Una vez por usuario: después
  // manda el selector de la barra superior (que además lo guarda en el perfil).
  useEffect(() => {
    if (userId === undefined || applied.current === userId) return;
    applied.current = userId;
    if (locale !== undefined) void setLanguage(toLanguage(locale));
  }, [userId, locale]);

  if (me.isPending) return <LoadingClinic />;
  if (me.isError) {
    return (
      <main>
        <ErrorBanner message={t('errors.INTERNAL')} onRetry={() => void me.refetch()} />
      </main>
    );
  }
  if (me.data === null) return <Navigate to="/login" replace />;
  if (me.data.activeClinicId == null) return <Navigate to="/select-clinic" replace />;

  return (
    <div className="app">
      <Rail permissions={me.data.permissions ?? []} logoUrl={me.data.logoUrl ?? null} />
      <div className="col">
        <OfflineBanner />
        <TopBar me={me.data} />
        <main id="main">
          <Outlet />
        </main>
      </div>
      <SessionWarning />
    </div>
  );
}
